export const WEEKDAYS = ["일", "월", "화", "수", "목", "금", "토"];
export const CALENDAR_DAYS = ["일", "월", "화", "수", "목", "금", "토"];
export const TIME_SLOTS = ["14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00", "21:00"];

export function uid(prefix) {
  return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
}

export function toDateKey(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function todayKey() {
  return toDateKey(new Date());
}

export function academyDateKey(date = new Date()) {
  return new Intl.DateTimeFormat("sv-SE", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

export function formatDate(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("ko-KR", { year: "numeric", month: "2-digit", day: "2-digit" });
}

export function getMonthCells(cursor) {
  const first = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
  const daysInMonth = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 0).getDate();
  const cells = Array.from({ length: first.getDay() }, () => null);
  for (let day = 1; day <= daysInMonth; day += 1) {
    cells.push(toDateKey(new Date(cursor.getFullYear(), cursor.getMonth(), day)));
  }
  return cells;
}

export function dateRange(start, end) {
  if (!start || !end) return [];
  const from = new Date(start);
  const to = new Date(end);
  const dates = [];
  for (let d = from; d <= to; d.setDate(d.getDate() + 1)) dates.push(toDateKey(new Date(d)));
  return dates;
}

export function isBetween(date, start, end) {
  const min = start < end ? start : end;
  const max = start > end ? start : end;
  return date >= min && date <= max;
}

export function seasonColor(month) {
  if ([2, 3, 4].includes(month)) return "#eaf5ed";
  if ([5, 6, 7].includes(month)) return "#e5f1fb";
  if ([8, 9, 10].includes(month)) return "#f6ead5";
  return "#f8e8ec";
}
